import { Caption, Heading2, Typography } from '@casavo/base-ui'
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { LabelWithCheck } from '@/components/LabelWithCheck'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { ListingCate } from '@/page-commons/listingBySlug'

import CasavoPropertyTitle from './CasavoPropertyTitle'
import { orange600 } from './styles.css'

type Props = {
  property: ListingCate
}

const FormHeaderMobile: React.FC<Props> = ({ property }) => {
  const { t } = useTranslation()

  return (
    <>
      <Heading2
        className={sprinkles({ paddingBottom: property.contactInfo.ownedByCasavo ? 'l' : '2xl', paddingRight: 'm' })}
      >
        <Trans
          components={[
            <span key="0" className={sprinkles({ display: 'block' })} />,
            <span key="1" className={orange600} />,
          ]}
          i18nKey={
            property.contactInfo.ownedByCasavo ? 'contact-form:casavo.title' : 'listing-detail:at_your_service_agency'
          }
        />
      </Heading2>
      {property.contactInfo.ownedByCasavo ? (
        <CasavoPropertyTitle titles={property.detail?.titles} />
      ) : (
        <div className={sprinkles({ paddingBottom: '2xl' })}>
          <div
            className={sprinkles({
              paddingBottom: 'l',
            })}
          >
            <Typography variant="bodyM">
              <strong>{property.contactInfo.agencyName}</strong>
            </Typography>
            <Caption color="greyscale500">{property.contactInfo.agencyAddress}</Caption>
          </div>

          <LabelWithCheck>{t('listing-detail:form-header.agency.one')}</LabelWithCheck>
          <LabelWithCheck>{t('listing-detail:form-header.agency.two')}</LabelWithCheck>
        </div>
      )}
    </>
  )
}

export default FormHeaderMobile
